import type { ICodeSessionListItem } from "@frontend-shared/types";
import { isToday, isYesterday } from "date-fns";

export type TSessionDayKind = "today" | "yesterday" | "date";

export interface ISessionDayGroup {
  id: string;
  kind: TSessionDayKind;
  date: string;
  sessions: ICodeSessionListItem[];
}

const resolveDayKind = (date: Date): TSessionDayKind => {
  if (isToday(date)) {
    return "today";
  }
  if (isYesterday(date)) {
    return "yesterday";
  }
  return "date";
};

// NOTE: The sidebar lists sessions the way the chat history lists chats — by
// the day they started, newest first. Grouping keys off the viewer's local
// calendar day, so "Today" means today where the user is, not in UTC.
export const groupSessionsByDay = (
  sessions: ICodeSessionListItem[],
): ISessionDayGroup[] => {
  const groups: ISessionDayGroup[] = [];

  for (const session of sessions) {
    const date = new Date(session.createdAt);
    if (Number.isNaN(date.getTime())) {
      continue;
    }

    const id = date.toDateString();
    const existing = groups.find((group) => group.id === id);
    if (existing) {
      existing.sessions.push(session);
      continue;
    }

    groups.push({
      id,
      kind: resolveDayKind(date),
      date: session.createdAt,
      sessions: [session],
    });
  }

  return groups;
};
